module.exports = __webpack_public_path__ + "main/assets/public/subscribe-form/edit.14378b63a0b17bd7.svg";